import { render, staticRenderFns } from "./AccountBalanceRecord.vue?vue&type=template&id=52781055&"
import script from "./AccountBalanceRecord.vue?vue&type=script&lang=js&"
export * from "./AccountBalanceRecord.vue?vue&type=script&lang=js&"
import style0 from "./AccountBalanceRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports